import { isEntitled } from '../../../../utils/common';
import { Empty } from '../../../../web/components/empty';
import React, { Component } from 'react';
import { MatchedLoadContainer } from '../../MatchedLoadContainer/index';
import { NewContainer } from '../NewContainer';
import FavouriteContainer from '../SavedSearchcontainer/FavouriteContainer/FavouriteContainer';
import RecentContainer from '../SavedSearchcontainer/RecentContainer/RecentContainer';
import { matchedLoadAccessText, searchLoadsButton } from '../../../../utils/constants';

class SectionContainer extends Component<any, any> {
  renderSwitch(section: string) {
    switch (section) {
      case 'New Search':
        return (
          <NewContainer
            isRecentSearch={this.props.isRecentSearch}
            searchParams={this.props.searchParams}
            doScroll={this.props.doScroll}
          />
        );
      case 'Recent Search':
        return <RecentContainer onRedirectToTab={this.props.onRedirectToTab} tabFrom="recent" />;
      case 'Favorite Search':
        return (
          <FavouriteContainer onRedirectToTab={this.props.onRedirectToTab} tabFrom="favorite" />
        );
      case 'Matched Loads':
        if (!(isEntitled('home', 'recommended') || isEntitled('home', 'watched'))) {
          return (
            <Empty
              constantText={matchedLoadAccessText}
              constantButton={searchLoadsButton}
              handleClick={() => this.props.onRedirectToTab('New Search')}
            />
          );
        }
        return <MatchedLoadContainer clearTopRecommedLoadDetails={this.props.clearTopRecommedLoadDetails} tabCallbackSegmentChange={this.props.tabCallbackSegmentChange} {...this.props} />;
      case 'Watched Loads':
        if (!isEntitled('home', 'watched')) {
          return (
            <Empty
              constantText={matchedLoadAccessText}
              constantButton={searchLoadsButton}
              handleClick={() => this.props.onRedirectToTab('New Search')}
            />
          );
        }
        return <MatchedLoadContainer watchedTab={true} onRedirectToTab={this.props.onRedirectToTab} clearTopRecommedLoadDetails={this.props.clearTopRecommedLoadDetails} tabCallbackSegmentChange={this.props.tabCallbackSegmentChange} {...this.props} />;
      case 'Recommended Loads':
        if (!(isEntitled('home', 'recommended'))) {
          return (
            <Empty
              constantText={matchedLoadAccessText}
              constantButton={searchLoadsButton}
              handleClick={() => this.props.onRedirectToTab('New Search')}
            />
          );
        }
        return <MatchedLoadContainer recommendationTab={true} clearTopRecommedLoadDetails={this.props.clearTopRecommedLoadDetails} tabCallbackSegmentChange={this.props.tabCallbackSegmentChange} {...this.props} />;
      default:
        return <NewContainer doScroll={this.props.doScroll}/>;
    }
  }

  render() {
    return this.renderSwitch(this.props.section);
  }
}

export default SectionContainer;
